module.exports = __webpack_public_path__ + "img/tzc.36de4721.svg";